import React from 'react'
import { getMessage } from 'lib/translator'
import emptyIcon from 'icons/no-orders.svg'
import { SALES_ORDERS_PAY_URL } from 'config/app'

import SalesOrderTableView from '../View'
import FilterNewSalesOrdersFilter from './FilterNewSalesOrdersFilter'
import '../style.scss'
import NewListingPage from 'containers/NewListingPage'
// import ListingPage from 'containers/ListingPage'

export const processFormDataFilter = (obj = {}) => {
  return {
    filter: Object.entries(obj)
      .map(([key, value]) => `${key}=${value}`)
      .join(';'),
  }
}

const SalesOrdersTable = ({ menu }) => {
  return (
    <NewListingPage
      menu={menu}
      primaryKey="referenceNumber"
      title={getMessage('operations.dashboard.redeliveryOrders')}
      className={`sale-orders-page`}
      testid="sales-orders-page"
      tableProperties={SalesOrderTableView()}
      tableDynamic
      emptyState={{
        icon: emptyIcon,
        message: getMessage('saleOrder.listing.emptyPage'),
      }}
      api={{
        url: `${SALES_ORDERS_PAY_URL}/ListClientSalesOrders`,
        method: 'post',
        transform: (response) => {
          response.count = response?.totalSize
          response.pageSize = 20
          return response.results
        },
        updatePageParams: ({ page, nextPageToken }) => {
          return {
            pageToken: page > 1 ? nextPageToken : '',
          }
        },
        params: {
          maxPageSize: 20,
        },
      }}
      filters={{
        component: FilterNewSalesOrdersFilter,
        forceShow: true,
        transformSubmit: (formData) => {
          const result = processFormDataFilter(formData)
          Object.keys(formData).forEach((key) => {
            delete formData[key]
          })
          return result
        },
      }}
    />
  )
}

export default SalesOrdersTable
